module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/mobile-ed1837b12351b636c79a2648098ebbbb.jpeg";